import { get } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getExperiment } from 'components/experiment/selectors';

export const getCmsExperimentData = get([
  'commonSearch',
  'cms',
  'result',
  'ab-testing-config',
]);

export const getNumberOfResultsExpResult = createSelector(
  getExperiment,
  (experiment) =>
    get(['name'], experiment) === 'numberOfResults' ? experiment : null,
);
